<template>
  <PaOverlayModal
   :appendClass="['pa-overlay-modal-default-transition-upper', 'pa-character-application-detail-modal']"
   :additionalZIndex="2"
   :isOpen="isOpenModal"
   :position="{top: .1}"
   :isFreez="isFreezModal"
   :couldOverlaySwipeClose="false"
   contentTransitionName="trans-content"

   @closeOverlayModal="handleCloseOverlay"
   @afteredAfterEnterContent="handleAfterEnterContent"
  >
    <div class="pa-wide-modal-box-wrapper pa-message-application-status-detail">
      <div class="pa-wide-modal-box" ref="wideModalBox">
        <div class="character-application-detail" v-if="isDataLoaded">
          <!-- {{characterApplication.id}} -->
          <div class="head" ref="head">
            <p class="title-mini">塔経市帝</p>
            <p class="title">電子申請状況照会情報システム</p>
            <ul class="status-indicator">
              <li v-for="(status, index) in applicationStatusList" :key="index" :class="status.classList">
                <component :is="status.componentName" />
              </li>
            </ul>
          </div>

          <div class="content" ref="content">
            <p class="title">申請内容</p>
            <div class="detail">
              <div class="value-set" v-if="applicationTypeText !== ''">
                <p class="key">申請種別</p>
                <p class="value">{{applicationTypeText}}</p>
              </div>

              <div class="value-set" v-for="data in contentTextKeyValues" :key="data.key">
                <p class="key">{{data.key}}</p>
                <p class="value">{{data.value}}</p>
              </div>

              <div class="value-set" v-if="applicationResultText !== ''">
                <p class="key">申請結果</p>
                <p class="value">{{applicationResultText}}</p>
              </div>
            </div>
          </div>

          <div class="footer" ref="footer">
            <button
             class="button"
             @click.prevent="handleClickClose"
            >閉じる</button>
          </div>
        </div>
      </div>

      <transition name="pa-simple-fade" @beforeEnter="handleBeforeEnterLoading">
        <div class="pa-loading-set" v-if="isLoading">
          <div class="pa-loading-field" ref="loadingContent">
            <PuffLoadingImage stroke="#957E63" />
          </div>
          <div class="pa-loading-overlay" ref="loadingOverlay"></div>
        </div>
      </transition>
    </div>
  </PaOverlayModal>
</template>

<script>
import PaOverlayModal from '@/components/Parts/PAOverlayModal/PAOverlayModal.vue'
import PuffLoadingImage from '@/components/Pages/Connections/ConnectionApp/Images/puff.svg?inlineN'

import {GetCharacterApplication} from '@/graphql/queries/CharacterApplication.graphql'

import ApplicationStatusImage1 from '@/components/Parts/PACharacterApplicationDetailModal/Images/application_status_1_1.svg?inlineN'
import ApplicationStatusImage2 from '@/components/Parts/PACharacterApplicationDetailModal/Images/application_status_2_1.svg?inlineN'
import ApplicationStatusImage3 from '@/components/Parts/PACharacterApplicationDetailModal/Images/application_status_3_1.svg?inlineN'

export default {
  components : {
    PaOverlayModal,
    PuffLoadingImage,

    ApplicationStatusImage1,
    ApplicationStatusImage2,
    ApplicationStatusImage3
  },

  data(){
    return {
      isOpenModal             : false,
      isFreezModal            : false,

      characterApplicationId  : null,

      isEnterdModal           : false,

      isLoading               : false,
      
      isDataLoaded            : false,

      applicationStatusList   : {
        receive     : {
          componentName : 'ApplicationStatusImage1',
          classList     : {
            'is-active' : true
          },
        },

        processing  : {
          componentName : 'ApplicationStatusImage2',
          classList     : {
            'is-active' : false
          },
        },

        finish      : {
          componentName : 'ApplicationStatusImage3',
          classList     : {
            'is-active' : false
          },
        }
      },

      applicationTypeText   : '',
      contentTextKeyValues  : [],
      applicationResultText : '',
    };
  },

  computed : {
    urlQuery(){
      return this.$route.query;
    },

    isDataLoading(){
      return this.$apollo.queries.characterApplication?.loading;
    },

    isMountedLoginedViewPage(){
      return this.$store.state.layouts.isMountedLoginedViewPage;
    },
  },

  apollo : {
    characterApplication  : {
      query : GetCharacterApplication,

      variables(){
        return {
          id  : this.characterApplicationId
        }
      },

      skip(){
        if(this.characterApplicationId === null){
          return true;
        }else{
          return false;
        }
      },

      result(){
        this.isDataLoaded = true;
      },

      fetchPolicy: 'no-cache'
    }
  },

  watch : {
    characterApplication : {
      handler(data){
        if(typeof data === 'undefined') return;

        switch(data.result){
          case 'pending':
            this.applicationStatusList.receive.classList['is-active']    = false;
            this.applicationStatusList.processing.classList['is-active'] = true;
            this.applicationStatusList.finish.classList['is-active']     = false;
            
            this.applicationResultText = '審査中';
          break;

          case 'rejected':
            this.applicationStatusList.receive.classList['is-active']    = false;
            this.applicationStatusList.processing.classList['is-active'] = false;
            this.applicationStatusList.finish.classList['is-active']     = true;

            this.applicationResultText = '非承認';
          break;

          case 'approved':
            this.applicationStatusList.receive.classList['is-active']    = false;
            this.applicationStatusList.processing.classList['is-active'] = false;
            this.applicationStatusList.finish.classList['is-active']     = true;

            this.applicationResultText = '承認';
          break;
        }

        switch(data.applicationType){
          case 'park':
            this.applicationTypeText = 'ひろば開設申請';

            this.contentTextKeyValues    = [
              {
                key   : '名称',
                value : data.park.name
              },
              {
                key   : '一言説明',
                value : data.park.caption
              },
              {
                key   : '説明',
                value : data.park.description
              }
            ]
          break;
        }

        
      }
    },

    isDataLoading : {
      handler(value){
        this.isLoading = value;
      }
    },

    urlQuery : {
      handler(data){
        if(typeof data !== 'object') return;

        if( typeof data.character_application_detail_id === 'undefined' )
        {
          this.characterApplicationId = null;
        }else{
          this.characterApplicationId = data.character_application_detail_id;
        }

        this.isEnterdModal = false;
      },
      immediate: true,
      deep: true
    },

    characterApplicationId : {
      handler(value){
        if(typeof value === 'undefined') return;
        if(value === null) return;
        
        if(this.isOpenModal === false){
          setTimeout(() => {
            this.isOpenModal = true;
          }, 250);
        }
      },
      immediate: true
    },

    isEnterdModal : {
      handler(){
        this.calcContentHeight();
      }
    },

    isMountedLoginedViewPage : {
      handler(){
        this.calcContentHeight();
      }
    }
  },

  methods : {
    handleClickClose(){
      this.isOpenModal = false;
    },

    calcContentHeight(){
      if(this.isEnterdModal === false) return;
      if(this.isMountedLoginedViewPage === false) return;

      let contentHeight = window.innerHeight - (window.innerHeight * .25);
      contentHeight = contentHeight - this.$refs.head.offsetHeight;
      contentHeight = contentHeight - this.$refs.footer.offsetHeight;

      this.$refs.content.style.height = contentHeight+'px';
    },

    handleCloseModal(){
      this.isOpenModal = false;
    },

    handleCloseOverlay(){
      this.isOpenModal = false;

      const newUrlQuery = Object.assign({}, this.$route.query);

      if(newUrlQuery['y'] === 0){
        delete newUrlQuery.y;
      }

      delete newUrlQuery.character_application_detail_id;

      this.$router.push({
        name    : this.$route.name,
        params  : this.$route.params,
        query   : newUrlQuery
      });
    },

    handleAfterEnterContent(){
      this.$nextTick(() => {
        this.isEnterdModal = true;
      });
    },

    handleBeforeEnterLoading(){
      const boxHeight = this.$refs.wideModalBox.offsetHeight;

      this.$refs.loadingContent.style.height = boxHeight + 'px';
      this.$refs.loadingOverlay.style.height = boxHeight + 'px';
    },
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.pa-message-application-status-detail{
  .character-application-detail{
    .head{
      p{
        color:#242424;
        text-align: center; 
        margin:0 auto;

        &.title-mini{
          font-family: 'mplus-1m-medium';
          letter-spacing: 2px;
          padding:1.1rem 0 2px;
          font-size: .9rem;

          @include until(375px) {
            padding:.8rem 0 2px;
            font-size: .85rem;
          }
        }

        &.title{
          width:95%;
          font-size:1.3rem;
          font-family: 'mplus-1m-regular';
          letter-spacing: 2px;
          margin-bottom:.7rem;
          border-bottom: 2px solid #242424;
          padding-bottom:.3rem;

          @include until(375px) {
            font-size:1.1rem;
          }
        }
      }

      ul.status-indicator{
        width:90%;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: space-around;

        li{
          opacity:.3;

          &.is-active{
            opacity:1;
          }

          svg{
            width:100%;
          }
        }
      }
    }

    .content{
      overflow-y: scroll;

      p.title{
        width:95%;
        margin:.5rem auto 0;
        border-top:2px solid #C1A582;
        color:#242424;
        text-align: center;
        font-size:1.2rem;
        padding:1rem 0;
        font-family: 'mplus-1m-regular';
        letter-spacing: 3px;

        @include until(375px) {
          padding:.6rem 0;
          font-size:1rem;
        }
      }

      .detail{
        width:90%;
        margin:0 auto;

        .value-set{
          background-color: #C8AC8A;
          border-radius: 8px;
          margin-bottom:1.2rem;

          @include until(375px) {
            margin-bottom:.6rem;
          }

          .key{
            box-sizing: border-box;
            width:95%;
            margin:0 auto;
            padding:4px 8px 2px;
            font-size: .9rem;
            color:#513F28;
            border-bottom: 1px solid #BB9F7E;

            @include until(375px) {
              font-size: .7rem;
            }
          }

          .value{
            padding:6px 8px;
            font-size: 1rem;
            text-align: center;
            color:#242424;

            @include until(375px) {
              font-size: .8rem;
            }
          }

          &:last-child{
            margin-bottom:0;
          }
        }
      }
    }

    .footer{
      background-color: inherit;
      padding:10px 0;
      text-align: center;

      @include until(375px) {
        padding:5px 0 10px;
      }

      button.button{
        margin:0 auto;
        padding:0;
        height: inherit;
        border:0;
        border-radius: 0;
        background-color: inherit;
        font-size: 1.2rem;
        border-bottom: 2px solid #242424;

        @include until(375px) {
          font-size: .9rem;
        }
      }
    }
  }
  
  .pa-loading-set{
    .pa-loading-field, .pa-loading-overlay{
      z-index: 1;
      position:absolute;
      top:0;
      left:0;
      width:100%;
      height:500px;
      text-align: center;

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .pa-loading-overlay{
      z-index:0;
      background:linear-gradient(0deg, rgba($body-background-darker, .7), rgba($body-background-darker, .5));
      backdrop-filter: blur(3px) opacity(.9);
    }
  }
}
</style>